// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon[data-v-04ab44ec]{font-size:20px;line-height:18px}.link[data-v-04ab44ec]{all:unset}.bottom-popup[data-v-04ab44ec]{position:fixed}", ""]);
// Exports
module.exports = exports;
